export default __webpack_public_path__ + "static/media/Firstmeet6.ade4b7e0.jpg";